import Vue from 'vue';
import App from '@/app';

import { isObject } from '@/utilities';

function init (el, binding) {
  let options = {
    threshold: 0.10
  }    

  let observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting || entry.intersectionRatio > 0) {

        // Create a new Image object
        let img = new Image();

        // Incase we want to add a css effect
        el.classList.add('js-lazy', 'js-lazy--loading');

        // Setup an onload event for the image
        img.onload = () => {
          if (el.nodeName.toLowerCase() === 'img') {
            // Use img src
            el.setAttribute('src', img.src);
          } else {
            // Use background image style
            el.style.backgroundImage = `url('${ img.src }')`;
          }

          // Add a loaded class which we can use to remove the css effect
          el.classList.remove('js-lazy--loading');
        }

        // Set the image src to trigger the image to load
        if (isObject(binding.value)) {
          img.src = App.$mq('xs-max') ? binding.value.mobile : binding.value.desktop;
        } else {
          img.src = binding.value;
        }

        // Remove the observer as the element is now within view
        observer.unobserve(el);
        observer = null;
      }
    });
  }, options);

  // Start the observer
  observer.observe(el);
}

Vue.directive('lazy', {
  bind: function (el, binding) {
    // If binding has a value when the directive binds to the element
    // then we can run init()
    if (binding.value && binding.value.length > 0 || isObject(binding.value)) {
      init(el, binding);
    }
  },

  update: function (el, binding) {
    // If binding didn't have a value when the directive was initially bound to the element
    // then run init() when the old and current values do not match
    if (typeof binding.value === 'object') {
      if (binding.value.desktop === binding.oldValue.desktop) { 
        return;
      }
    } else if (binding.value === binding.oldValue) {
      return;
    }

    init(el, binding);
  }
});


// WEBPACK FOOTER //
// ./resources/assets/js/app/directives/lazy/index.js